import React, { useEffect, useState, useRef } from 'react';
import GeneratePdf from '../../../../components/GeneratePdf';
import { getFormatedNumber } from '../../../../services/appService';
import GenerateExcel from "../../../../components/GenerateExcel";
import { useDispatch, useSelector } from 'react-redux';
import { getCandidateVisaStatusRpt, loadCandidateVisaStatusRpt } from '../../../store/reports';
import Moment from 'react-moment';
import SearchableSelect from '../../../../comman/SearchableSelect';

const CandidateVisaStatus = () => {
    const [selectedEntityType, setSelectedEntityType] = useState(0);
    const [visaExpired, setVisaExpired] = useState(0);
    const [candidateVisaReports, setCandidateVisaReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [excelShowHide, setExcelShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [visaType, setVisaType] = useState("");

    // Live search, loading, and scroll sync states
    const [tableSearchTerm, setTableSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [tableWidth, setTableWidth] = useState(0);
    const topScrollRef = useRef(null);
    const tableWrapperRef = useRef(null);

    const entityTypes = [
        { id: 1, name: "C2C Candidates", pmId: 67 },
        { id: 2, name: "W2 Candidates", pmId: 69 },
        { id: 3, name: "1099 Candidates", pmId: 70 },
    ];

    const visaStatus = [
        { value: "H1B", label: "H1B" },
        { value: "EAD_GC", label: "EAD-GC" },
        { value: "TN", label: "TN" },
        { value: "Green_C", label: "Green Card" },
        { value: "US_Citizen", label: "US Citizen" },
        { value: "H4_EAD", label: "H4 EAD" },
        { value: "F1_OPT", label: "F1-OPT" },
        { value: "F1_CPT", label: "F1-CPT" },
        { value: "L1", label: "L1" },
        { value: "Canadian Citizen", label: "Canadian Citizen" }
    ];

    const visaTypeOptions = [
        { value: "", label: "All Visa Types" },
        ...visaStatus.map(v => ({ value: v.value, label: v.label }))
    ];

    const expirationOptions = [
        { value: 0, label: "Expiration Status" },
        { value: 1, label: "Expired" },
        { value: 2, label: "Active" },
        { value: 3, label: "Data not submitted" }
    ];

    const candidateVisaStatusRpt = useSelector(getCandidateVisaStatusRpt);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedEntityType === 0) {
            setCandidateVisaReports([]);
            return;
        }
        setCandidateVisaReports(candidateVisaStatusRpt || []);
        setIsLoading(false);
    }, [candidateVisaStatusRpt]);

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const handleexcelShowHide = () => {
        setExcelShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const handleEntityTypeSelect = (pmId) => {
        if (isLoading || Number(selectedEntityType) === pmId) return;
        setSelectedEntityType(pmId);
        setCandidateVisaReports([]);
        setIsLoading(true);
        dispatch(loadCandidateVisaStatusRpt(pmId, visaExpired, 0, 0));
        setTableSearchTerm("");
    };

    const handleVisaExpiredChange = (e) => {
        const rawVal = e?.target?.value ?? e;
        const parsed = parseInt(rawVal);
        const val = isNaN(parsed) ? 0 : parsed;
        setVisaExpired(val);
        setCandidateVisaReports([]);
        if (selectedEntityType !== 0) {
            setIsLoading(true);
            dispatch(loadCandidateVisaStatusRpt(selectedEntityType, val, 0, 0));
        }
    };

    const handleVisaTypeChange = (e) => {
        const val = e?.target?.value ?? e;
        setVisaType(val || "");
    };

    const getFilteredReports = () => {
        if (!candidateVisaReports) return [];
        return candidateVisaReports.filter(item => {
            const term = tableSearchTerm.toLowerCase();
            const matchesSearch = 
                (item.keyName || "").toLowerCase().includes(term) ||
                (item.keyEmail || "").toLowerCase().includes(term) ||
                (item.keyPhone || "").toLowerCase().includes(term) ||
                String(item.keyId || "").toLowerCase().includes(term);
            
            const matchesVisaType = visaType === "" || item.visaType === visaType;
            
            return matchesSearch && matchesVisaType;
        });
    };

    const filteredReports = getFilteredReports();

    // Stats calculations
    const getKpiStats = () => {
        if (!candidateVisaReports || candidateVisaReports.length === 0) {
            return { totalCount: 0, uniqueVisas: 0, expiredCount: 0, activeCount: 0 };
        }
        const totalCount = candidateVisaReports.length;
        const uniqueVisas = new Set(
            candidateVisaReports.map(x => x.visaType).filter(Boolean)
        ).size;
        
        let expiredCount = 0;
        let activeCount = 0;
        
        candidateVisaReports.forEach((item) => {
            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());
                
                if (expDateOnly < todayOnly) {
                    expiredCount++;
                } else {
                    activeCount++;
                }
            }
        });
        
        return { totalCount, uniqueVisas, expiredCount, activeCount };
    };

    const { totalCount, uniqueVisas, expiredCount, activeCount } = getKpiStats();

    // Dual scrollbars synchronization
    const handleTopScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
    };

    const handleTableScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
        }
    };

    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const updateWidth = () => {
            const table = document.getElementById("sub_ach_rpt");
            const wrapper = tableWrapperRef.current;
            if (table && wrapper) {
                setTableWidth(table.scrollWidth);
                setIsScrollable(table.scrollWidth > wrapper.clientWidth + 5);
            } else {
                setIsScrollable(false);
            }
        };
        
        updateWidth();
        const timer = setTimeout(updateWidth, 300);
        
        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
            clearTimeout(timer);
        };
    }, [filteredReports, selectedEntityType]);

    const candidateVisaExportPDF = () => {
        let headers = [
            [
                "ID",
                "Name",
                "Email",
                "Phone",
                "Visa Type",
                "Visa Expiration Date",
                "Visa Status",
            ],
        ];

        let data = [];
        filteredReports.forEach((item) => {
            let visaExpirationStatus = "Data not submitted";
            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());
                visaExpirationStatus = expDateOnly < todayOnly ? "Expired" : "Active";
            }
            data.push([
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
                visaStatus.find((v) => v.value === item.visaType)?.label || 'N/A',
                item.visaExpiration ? new Date(item.visaExpiration).toLocaleDateString() : 'N/A',
                visaExpirationStatus,
            ]);
        });
        
        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);
    }

    const candidateVisaExportExcel = () => {
        let headers = [
            [
                "ID",
                "Name",
                "Email",
                "Phone",
                "Visa Type",
                "Visa Expiration Date",
                "Visa Status",
            ],
        ];

        let data = [];
        filteredReports.forEach((item) => {
            let visaExpirationStatus = "Data not submitted";
            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());
                visaExpirationStatus = expDateOnly < todayOnly ? "Expired" : "Active";
            }
            data.push([
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
                visaStatus.find((v) => v.value === item.visaType)?.label || 'N/A',
                item.visaExpiration ? new Date(item.visaExpiration).toLocaleDateString() : 'N/A',
                visaExpirationStatus,
            ]);
        });
        
        setSelectedCol(headers);
        setSelectedColData(data);
        setExcelShowHide(true);
    };

    return (
        <div className="cvs-report-container">
            <style>{`
                .cvs-report-container {
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    color: #1e293b;
                    margin-bottom: 2rem;
                }

                /* Visual selector cards */
                .cvs-card-selector {
                    margin-bottom: 12px;
                }

                .cvs-select-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 13px 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                    height: 100%;
                    position: relative;
                }

                .cvs-select-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.06);
                    border-color: #cbd5e1;
                }

                .cvs-select-card.active {
                    background: #ffffff !important;
                    border: 1.5px solid #171717 !important;
                    box-shadow: 0 6px 18px -4px rgba(15, 23, 42, 0.08), inset 4px 0 0 0 #171717 !important;
                }

                .cvs-select-card.active .cvs-select-card-title {
                    color: #1e293b !important;
                    font-weight: 500 !important;
                }

                .cvs-select-card.active .cvs-select-card-desc {
                    color: #525252 !important;
                }

                .cvs-select-card-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 0 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    flex-shrink: 0;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    transition: all 0.2s ease;
                }

                .cvs-select-card.active .cvs-select-card-icon {
                    background: #171717 !important;
                    color: #ffffff !important;
                    border-color: #171717 !important;
                }

                .cvs-card-check-badge {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 18px;
                    height: 18px;
                    border-radius: 0 !important;
                    background: #171717;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    animation: badgePop 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                }

                @keyframes badgePop {
                    from { transform: scale(0.6); opacity: 0; }
                    to   { transform: scale(1); opacity: 1; }
                }

                .cvs-select-card:hover .cvs-select-card-icon {
                    transform: scale(1.05);
                }

                .cvs-select-card-title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #1e293b;
                    margin-bottom: 2px;
                }

                .cvs-select-card-desc {
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    line-height: 1.3;
                }

                /* KPI Metric cards */
                .cvs-kpi-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
                    gap: 14px;
                    margin-bottom: 12px;
                }

                .cvs-metric-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 12px 16px;
                    display: flex;
                    align-items: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
                }

                .cvs-metric-icon {
                    width: 36px;
                    height: 36px;
                    border-radius: 0 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    margin-right: 12px;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    flex-shrink: 0;
                }

                .cvs-metric-val {
                    font-size: 18px;
                    font-weight: 500;
                    color: #1e293b;
                    line-height: 1.1;
                    margin-bottom: 2px;
                }

                .cvs-metric-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.02em;
                }

                /* Controls Layout */
                .cvs-report-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 1rem;
                    margin-bottom: 12px;
                    background-color: #fafbfc;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 12px 16px;
                }

                .cvs-controls-group {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .cvs-search-wrapper {
                    position: relative;
                    width: 240px;
                }

                .cvs-search-input {
                    width: 100%;
                    padding: 8px 12px 8px 34px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 0 !important;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1e293b;
                    transition: all 0.2s ease;
                }

                .cvs-search-input:focus {
                    outline: none;
                    border-color: #171717;
                    box-shadow: 0 0 0 3px rgba(23, 23, 23, 0.1);
                }

                .cvs-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 12px;
                }

                .cvs-filter-select {
                    height: 35px;
                    border: 1px solid #cbd5e1;
                    border-radius: 0 !important;
                    padding: 0 10px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1e293b;
                    background: #ffffff;
                }

                .cvs-filter-select:focus {
                    outline: none;
                    border-color: #171717;
                }

                .cvs-actions-btns {
                    display: flex;
                    align-items: center;
                }

                .cvs-actions-btns > * {
                    margin-right: 8px !important;
                }

                .cvs-actions-btns > *:last-child {
                    margin-right: 0 !important;
                }

                .cvs-report-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 7px 14px;
                    border-radius: 0 !important;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #1e293b;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                    height: 35px !important;
                    min-height: 35px !important;
                    box-sizing: border-box !important;
                }

                .cvs-report-btn:hover:not(:disabled) {
                    background-color: #f5f5f5;
                    color: #1e293b;
                    border-color: #94a3b8;
                }

                .cvs-report-btn:disabled {
                    background-color: #ffffff !important;
                    border-color: #cbd5e1 !important;
                    color: #94a3b8 !important;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                    cursor: not-allowed;
                }

                /* Table modifications matching WorkflowUser */
                .cvs-report-table-wrapper {
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.01);
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar {
                    height: 6px !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-track {
                    background: #f1f5f9 !important;
                    border-radius: 0 !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                    border-radius: 0 !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(180deg, #64748b, #94a3b8) !important;
                }

                .cvs-report-table-wrapper::-webkit-scrollbar,
                .ach-report-body div::-webkit-scrollbar {
                    width: 6px !important;
                    height: 6px !important;
                }

                .cvs-report-table-wrapper::-webkit-scrollbar-track,
                .ach-report-body div::-webkit-scrollbar-track {
                    background: transparent !important;
                }

                .cvs-report-table-wrapper::-webkit-scrollbar-thumb,
                .ach-report-body div::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                    border-radius: 0 !important;
                    transition: all 0.2s ease !important;
                }

                .cvs-report-table-wrapper::-webkit-scrollbar-thumb:hover,
                .ach-report-body div::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(180deg, #64748b, #94a3b8) !important;
                }

                .cvs-report-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                    text-align: left;
                }

                .cvs-report-table thead {
                    background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                }

                .cvs-report-table thead tr {
                    background: transparent !important;
                }

                .cvs-report-table th {
                    background: transparent !important;
                    background-color: transparent !important;
                    color: #64748b !important;
                    font-weight: 600 !important;
                    font-size: 12px !important;
                    text-transform: uppercase !important;
                    letter-spacing: 0.6px !important;
                    padding: 13px 16px !important;
                    border-bottom: 2px solid #e2e8f0 !important;
                    border-top: none !important;
                    border-left: none !important;
                    border-right: none !important;
                    white-space: nowrap !important;
                }

                .cvs-report-table tbody tr {
                    transition: background 0.15s ease, box-shadow 0.15s ease !important;
                }

                .cvs-report-table tbody tr:hover {
                    background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
                    box-shadow: inset 3px 0 0 0 #171717 !important;
                }

                .cvs-report-table tbody tr:hover td {
                    color: #1e293b !important;
                }

                .cvs-report-table td {
                    padding: 13px 16px !important;
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    color: #1e293b !important;
                    border-bottom: 1px solid #f1f5f9 !important;
                    vertical-align: middle !important;
                    transition: color 0.15s ease !important;
                    white-space: nowrap !important;
                }

                .cvs-report-table tbody tr:last-child td {
                    border-bottom: none !important;
                }

                /* Shimmer and Loading Animation */
                @keyframes shimmer {
                  0%   { background-position: -600px 0; }
                  100% { background-position: 600px 0; }
                }

                @keyframes loadingBar {
                  0%   { width: 0%; opacity: 1; }
                  70%  { width: 85%; opacity: 1; }
                  100% { width: 100%; opacity: 0; }
                }

                .wf-loading-bar {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #171717, #737373, #171717);
                  background-size: 200% 100%;
                  animation: loadingBar 1.6s ease-in-out infinite;
                  z-index: 10;
                }

                .skeleton-cell {
                  display: block;
                  height: 12px;
                  border-radius: 0 !important;
                  background: linear-gradient(
                    90deg,
                    #f1f5f9 25%,
                    #e2e8f0 50%,
                    #f1f5f9 75%
                  );
                  background-size: 600px 100%;
                  animation: shimmer 1.4s ease-in-out infinite;
                }

                .skeleton-cell.sk-short  { width: 40%; }
                .skeleton-cell.sk-medium { width: 65%; }
                .skeleton-cell.sk-long   { width: 85%; }
                .skeleton-cell.sk-full   { width: 92%; }

                .skeleton-row td {
                  padding: 14px 16px !important;
                }

                /* Enhanced empty state */
                .wf-empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 50px 24px;
                  text-align: center;
                  gap: 12px;
                }

                .wf-empty-icon {
                  width: 52px;
                  height: 52px;
                  border-radius: 0 !important;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 22px;
                  background: #f5f5f5;
                  border: 1px solid #d4d4d4;
                  color: #171717;
                  margin-bottom: 4px;
                }

                .wf-empty-title {
                  font-size: 14px;
                  font-weight: 500;
                  color: #1e293b;
                  margin: 0;
                  width: 100%;
                  text-align: center;
                }

                .wf-empty-desc {
                  font-size: 14px;
                  font-weight: 400;
                  color: #64748b;
                  margin: 0 auto;
                  line-height: 1.6;
                  text-align: center;
                  width: 100%;
                }

                /* Visa status text with color */
                .badge-expired {
                    background: transparent !important;
                    color: #ef4444 !important;
                    border: none !important;
                    padding: 0 !important;
                    border-radius: 0 !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    display: inline !important;
                }

                .badge-active {
                    background: transparent !important;
                    color: #10b981 !important;
                    border: none !important;
                    padding: 0 !important;
                    border-radius: 0 !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    display: inline !important;
                }

                .badge-none {
                    background: transparent !important;
                    color: #64748b !important;
                    border: none !important;
                    padding: 0 !important;
                    border-radius: 0 !important;
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    display: inline !important;
                }

                .cvs-select-card.loading {
                    pointer-events: none;
                    opacity: 0.7;
                }

                .ach-pay-loading-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    margin-right: 10px;
                }

                .ach-pay-loading-status i {
                    color: #1e293b;
                }

            `}</style>

            <div className="cvs-card-selector">
                <div className="row">
                    {entityTypes.map((t) => {
                        const isActive = Number(selectedEntityType) === t.pmId;
                        const icons = {
                            67: "fa-building-o",
                            69: "fa-user",
                            70: "fa-user-circle-o"
                        };
                        
                        return (
                            <div className="col-md-4 mb-3" key={t.id}>
                                <div 
                                    className={`cvs-select-card ${isActive ? "active" : ""} ${isLoading ? "loading" : ""}`}
                                    onClick={() => handleEntityTypeSelect(t.pmId)}
                                >
                                    {isActive && !isLoading && (
                                        <div className="cvs-card-check-badge">
                                            <i className="fa fa-check"></i>
                                        </div>
                                    )}
                                    {isActive && isLoading && (
                                        <div className="cvs-card-check-badge">
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </div>
                                    )}
                                    <div className="cvs-select-card-icon">
                                        <i className={`fa ${icons[t.pmId]}`}></i>
                                    </div>
                                    <div className="cvs-select-card-body" style={{ flexGrow: 1, minWidth: 0, paddingRight: isActive ? "14px" : "0" }}>
                                        <div className="cvs-select-card-title">{t.name}</div>
                                        <div className="cvs-select-card-desc">
                                            {t.pmId === 67 && "Audit visas for Corp-to-Corp contractors."}
                                            {t.pmId === 69 && "Track work authorization details for W2 staff."}
                                            {t.pmId === 70 && "Verify visa legitimacy for 1099 contractors."}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {selectedEntityType !== 0 && (
                <div className="ach-report-body p-0">
                    <div className="cvs-report-controls">
                        <div className="cvs-controls-group">
                            <div className="cvs-search-wrapper">
                                <i className="fa fa-search cvs-search-icon"></i>
                                <input
                                    type="text"
                                    placeholder="Search by name, email, or phone..."
                                    className="cvs-search-input"
                                    value={tableSearchTerm}
                                    onChange={(e) => setTableSearchTerm(e.target.value)}
                                />
                            </div>

                            <SearchableSelect
                                id="visaTypeFilter"
                                name="visaTypeFilter"
                                value={visaType}
                                onChange={(e) => handleVisaTypeChange(e)}
                                options={visaTypeOptions}
                                placeholder="All Visa Types..."
                                size="sm"
                                width="180px"
                                icon="fa-id-card-o"
                            />

                            <SearchableSelect
                                id="insuranceExpired"
                                name="insuranceExpired"
                                value={visaExpired}
                                onChange={(e) => handleVisaExpiredChange(e)}
                                options={expirationOptions}
                                placeholder="Expiration Status..."
                                size="sm"
                                width="190px"
                                icon="fa-filter"
                            />
                        </div>

                        <div className="cvs-actions-btns">
                            {isLoading && (
                                <div className="ach-pay-loading-status">
                                    <i className="fa fa-spinner fa-spin"></i>
                                    <span>Loading visa records...</span>
                                </div>
                            )}
                            <button
                                type="button"
                                className="cvs-report-btn"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={candidateVisaExportExcel}
                            >
                                <i className="fa fa-file-excel-o" style={{ color: "#1e293b", marginRight: "6px" }} aria-hidden="true"></i>
                                Excel Export
                            </button>
                            <button
                                type="button"
                                className="cvs-report-btn"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={candidateVisaExportPDF}
                            >
                                <i className="fa fa-file-pdf-o" style={{ color: "#1e293b", marginRight: "6px" }}></i>
                                Export PDF
                            </button>
                        </div>
                    </div>

                    {selectedEntityType !== 0 && candidateVisaReports && candidateVisaReports.length > 0 && (
                        <div className="cvs-kpi-row">
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon">
                                    <i className="fa fa-users"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{totalCount}</div>
                                    <div className="cvs-metric-label">Total Records</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon">
                                    <i className="fa fa-globe"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{uniqueVisas}</div>
                                    <div className="cvs-metric-label">Visa Types</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon">
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{expiredCount}</div>
                                    <div className="cvs-metric-label">Expired Visas</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon">
                                    <i className="fa fa-check-circle-o"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{activeCount}</div>
                                    <div className="cvs-metric-label">Valid Visas</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Synchronized top scrollbar */}
                    {candidateVisaReports && candidateVisaReports.length > 0 && filteredReports.length > 0 && isScrollable && (
                        <div 
                            ref={topScrollRef}
                            onScroll={handleTopScroll}
                            className="ach-top-scrollbar-wrap"
                            style={{ overflowX: "auto", overflowY: "hidden", height: "8px", width: "100%", marginBottom: "2px" }}
                        >
                            <div style={{ width: `${tableWidth}px`, height: "1px" }}></div>
                        </div>
                    )}

                    <div 
                        ref={tableWrapperRef}
                        onScroll={handleTableScroll}
                        className="cvs-report-table-wrapper"
                        style={{ position: "relative" }}
                    >
                        {isLoading && <div className="wf-loading-bar" />}

                        {isLoading ? (
                            /* SKELETON TABLE LOADING SCREEN */
                            <table className="cvs-report-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Visa Type</th>
                                        <th>Visa Expiration Date</th>
                                        <th>Visa Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <tr key={`skel-${i}`} className="skeleton-row">
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : candidateVisaReports && candidateVisaReports.length > 0 ? (
                            filteredReports.length > 0 ? (
                                <table
                                    className="cvs-report-table"
                                    id="sub_ach_rpt"
                                >
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Visa Type</th>
                                            <th>Visa Expiration Date</th>
                                            <th>Visa Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredReports.map((item) => {
                                            let visaExpirationStatus = 3;
                                            if (item.visaExpiration) {
                                                const expDate = new Date(item.visaExpiration);
                                                const today = new Date();
                                                const expDateOnly = new Date(expDate.toDateString());
                                                const todayOnly = new Date(today.toDateString());
                                                visaExpirationStatus = expDateOnly < todayOnly ? 1 : 2;
                                            }

                                            return (
                                                <tr key={item.keyId}>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                    <td>
                                                        {visaStatus.find((v) => v.value === item.visaType)?.label || 'N/A'}
                                                    </td>
                                                    <td>
                                                        {item.visaExpiration && (
                                                            <Moment format="MMM Do, YYYY">{item.visaExpiration}</Moment>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {visaExpirationStatus === 1 && (
                                                            <span className="badge-expired">Expired</span>
                                                        )}
                                                        {visaExpirationStatus === 2 && (
                                                            <span className="badge-active">Active</span>
                                                        )}
                                                        {visaExpirationStatus === 3 && (
                                                            <span className="badge-none">N/A</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="wf-empty-state">
                                    <div className="wf-empty-icon">
                                        <i className="fa fa-search"></i>
                                    </div>
                                    <p className="wf-empty-title">No Matching Records</p>
                                    <p className="wf-empty-desc">No records matched your search query. Try adjusting your search term.</p>
                                </div>
                            )
                        ) : (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-folder-open-o"></i>
                                </div>
                                <p className="wf-empty-title">No Data Found</p>
                                <p className="wf-empty-desc">No visa status records found for this category on the server.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {selectedEntityType === 0 && (
                <div className="wf-empty-state" style={{ border: "1px dashed #cbd5e1", borderRadius: "0", background: "#f8fafc" }}>
                    <div className="wf-empty-icon">
                        <i className="fa fa-info-circle"></i>
                    </div>
                    <p className="wf-empty-title">No Category Selected</p>
                    <p className="wf-empty-desc">Select a candidate category above to inspect Visa compliance reports.</p>
                </div>
            )}

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
            <GenerateExcel
                handleexcelShowHide={handleexcelShowHide}
                excelShowHide={excelShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GenerateExcel>
        </div>
    );
};

export default CandidateVisaStatus;